import React, { FC, useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { Endpoint } from '../../../models/api.model';
import { APP_URLS } from '../../../consts';
import { useIframePageGetBySlugQuery } from '../../../libs/graphql/betzoneDirectusAPI/queries/__generated__/iframe-page-get-by-slug.query.generated';
import { useTranslations } from '../../../hooks/useTranslationsHelper';
import './FtpPage.scss';

export const FtpPage: FC = () => {
  const { slug = '' } = useParams();
  const auth = useAuth();
  const { t } = useTranslations();
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [sessionId] = useState(() => crypto.randomUUID());

  useEffect(() => {
    document.body.classList.add('combo');

    return () => {
      document.body.classList.remove('combo');
    };
  }, []);

  const { data, loading, error } = useIframePageGetBySlugQuery({
    variables: { slug },
    context: { endpoint: Endpoint.betzoneDirectusAPI },
    skip: auth.isAuthenticated,
  });

  if (auth.isAuthenticated) return <Navigate to={APP_URLS.itv.root} replace />;

  if (loading) {
    return (
      <main className="ftp-page">
        <p className="ftp-page__loading">{t('ftp.loading')}</p>
      </main>
    );
  }

  const iframeData = data?.iframe_pages?.[0];

  if (error || !iframeData) return <Navigate to={APP_URLS.itv.root} replace />;

  const iframeSrc = iframeData.src
    ? `${iframeData.src}${iframeData.src.includes('?') ? '&' : '?'}token=${sessionId}`
    : '';

  return (
    <main className="ftp-page">
      <div className="iframe-page">
        <div className="iframe-page__iframe-container">
          {!iframeLoaded && <p className="ftp-page__loading">{t('ftp.loading')}</p>}
          <iframe src={iframeSrc} title={iframeData.title || 'Game'} onLoad={(): void => setIframeLoaded(true)} />
        </div>
      </div>

      {iframeData.terms && <div className="ftp-terms">{iframeData.terms}</div>}
    </main>
  );
};
